import { Status } from 'Interfaces/BDPortalInterfaces';

export const getStatus = (stageID: number, status: Status[]) => {
  const allowedStatus = status.filter(item => {
    if (stageID === 8 && (item.ID === 1 || item.ID === 4 || item.ID === 5)) {
      return item;
    } else if (stageID !== 8 && (item.ID === 1 || item.ID === 2 || item.ID === 3)) {
      return item;
    }
  });
  return allowedStatus || [];
};
